import {
  section,
  image,
  socialContainer,
  socialTitle,
  socialButtons,
  socialButton,
  addressContainer,
  addressTitle,
  addressText,
  addressInnerContainer,
  socialInnerContainer,
} from './Footer.styles';

import LogoWhiteVertical from '../../assets/logowhitevertical1.png';
import { LuPhone, LuMapPin } from 'react-icons/lu';
import { FaInstagram, FaWhatsapp } from 'react-icons/fa';
import { useCallback, useState, useEffect } from 'react';
import { handleOpenLink } from '../../utils/common';

export default function Footer() {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    if (typeof window === 'undefined') return;

    const checkScreen = () => setIsMobile(window.innerWidth < 768);
    checkScreen();
    window.addEventListener('resize', checkScreen);
    return () => window.removeEventListener('resize', checkScreen);
  }, []);

  const getAddress = useCallback(
    () => (
      <div className={addressContainer}>
        <p className={addressTitle}>Informações</p>
        <button
          onClick={() =>
            handleOpenLink(
              'https://wa.me/+5519996268961?text=Ol%C3%A1,%20venho%20atrav%C3%A9s%20do%20site%20e%20gostaria%20de%20agendar%20uma%20Avalia%C3%A7%C3%A3o%20em%20Harmoniza%C3%A7%C3%A3o%20Orofacial%20com%20a%C2%A0Dra%C2%A0Bruna%C2%A0Fais.',
              'agendar_consulta_click',
              'Agendar consulta',
              window.location.pathname
            )
          }
          className={addressInnerContainer}
        >
          <LuPhone size={20} className='text-background' />
          <p className={addressText}>(19) 9 9626-8961</p>
        </button>
        <button
          onClick={() =>
            handleOpenLink(
              'https://www.google.com/maps/place/Dra.+Bruna+Fais/@-22.8982784,-47.0679552,14z/data=!4m6!3m5!1s0x94c8c50635e3c731:0xb171359db1ff61b9!8m2!3d-22.8599281!4d-47.0474129!16s%2Fg%2F11xf2p_kmq?entry=ttu&g_ep=EgoyMDI1MDgyNS4wIKXMDSoASAFQAw%3D%3D',
              'maps_click',
              'Acessar Endereço',
              window.location.pathname
            )
          }
          className={addressInnerContainer}
        >
          <LuMapPin size={20} className='text-background' />
          <div>
            <p className={addressText}>
              R. Jorge de Figueiredo Corrêa, 1323 - Sala 10
            </p>
            <p className={addressText}>Chácara Primavera, Campinas - SP</p>
            <p className={addressText}>13087-261</p>
          </div>
        </button>
      </div>
    ),
    []
  );

  const getSocial = useCallback(
    () => (
      <div className={socialContainer}>
        <img src={LogoWhiteVertical} alt='Logo clínica' className={image} />
        <div className={socialInnerContainer}>
          <p className={socialTitle}>Nossas Redes</p>
          <div className={socialButtons}>
            <button
              onClick={() =>
                handleOpenLink(
                  'https://wa.me/+5519996268961?text=Ol%C3%A1,%20venho%20atrav%C3%A9s%20do%20site%20e%20gostaria%20de%20agendar%20uma%20Avalia%C3%A7%C3%A3o%20em%20Harmoniza%C3%A7%C3%A3o%20Orofacial%20com%20a%C2%A0Dra%C2%A0Bruna%C2%A0Fais.',
                  'agendar_consulta_click',
                  'Agendar consulta',
                  window.location.pathname
                )
              }
              className={socialButton}
            >
              <FaWhatsapp className='text-title' size={isMobile ? 12 : 18} />
            </button>
            <button
              onClick={() =>
                handleOpenLink(
                  'https://www.instagram.com/drabfclinic/',
                  'instagram_click',
                  'Acessar Instagram',
                  window.location.pathname
                )
              }
              className={socialButton}
            >
              <FaInstagram className='text-title' size={isMobile ? 12 : 18} />
            </button>
          </div>
        </div>
        {!isMobile && getAddress()}
      </div>
    ),
    [isMobile, getAddress]
  );

  return (
    <footer className={section}>
      {getSocial()}
      {isMobile && getAddress()}
    </footer>
  );
}
